import {
    UPDATE_PRODUCT,
    UPDATE_PRODUCT_FAILURE,
    UPDATE_PRODUCT_SUCCESS,

    UPDATE_PRODUCT_LOCATION,
    UPDATE_PRODUCT_LOCATION_FAILURE,
    UPDATE_PRODUCT_LOCATION_SUCCESS,

    UPDATE_PRODUCT_ACTIVITY_FAILURE,
    UPDATE_PRODUCT_ACTIVITY_SUCCESS,
} from 'store/actions/types';

export const updateProduct = (payload) => {
    return {
        type: UPDATE_PRODUCT,
        payload: payload,
    };
};

export const updateProductFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_FAILURE,
        error: error,
    };
};

export const updateProductSuccess = (payload, response) => {
    return {
        type: UPDATE_PRODUCT_SUCCESS,
        payload: payload,
        response: response,
    };
};

export const updateProductLocation = (payload) => {
    return {
        type: UPDATE_PRODUCT_LOCATION,
        payload: payload,
    };
};

export const updateProductLocationFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_LOCATION_FAILURE,
        error: error,
    };
};

export const updateProductLocationSuccess = (payload, response) => {
    return {
        type: UPDATE_PRODUCT_LOCATION_SUCCESS,
        payload: payload,
        response: response,
    };
};

export const updateProductActivityFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_ACTIVITY_FAILURE,
        error: error,
    };
};

export const updateProductActivitySuccess = (response) => {
    return {
        type: UPDATE_PRODUCT_ACTIVITY_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/updateProducts.js